import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './Header.css'

const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <header className="header">
      <nav className="container nav-container">
        <Link to="/" className="logo">Roll Form Machine & Die</Link>
        
        <ul className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <li><Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link></li>
          <li><Link to="/products" onClick={() => setMobileMenuOpen(false)}>Products</Link></li>
          <li><Link to="/about" onClick={() => setMobileMenuOpen(false)}>About</Link></li>
          <li><Link to="/contact" onClick={() => setMobileMenuOpen(false)}>Contact</Link></li>
          <li className="mobile-quote-item"><Link to="/quote" onClick={() => setMobileMenuOpen(false)} className="mobile-quote-button">Request Quote</Link></li>
        </ul>
        
        <Link to="/quote" className="cta-button desktop-cta">Request Quote</Link>
        
        <button 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>
    </header>
  )
}

export default Header